// You can write your custom Javascript here

$(document).ready(function () {
  $(".pz--save").one("click",function(){ 
    $('.personalize-vue').after('<script>$("a.btn-close").click(function(){var o=0==$(".personalize__form--body input[type=text]").filter(function(){return 0==$.trim($(this).val()).length}).length;console.log(o),!0===o&&(console.log("true"),$("#addtocart").prop("disabled",!0),$("#pz-confirmed").prop("disabled",!1)),!1===o&&(console.log("false"),$("#addtocart").prop("disabled",!0),$("#pz-confirmed").prop("disabled",!0)),$("#addtocart").prop("disabled",!0)});</script>');   
  });
      setTimeout(function(){
$("body input#CLEAR-BIRTHSTONE").on("click",function(){
  console.log($(this));
  $("div.personalize__form").find("button[type='button']").attr("disabled", false);
});
    console.log("seption2");
  }, 3000);
  $(".pz--save").click(function(){
    var checkInput = $(".personalize__form--body input[type=text]").filter(function () {
      return $.trim($(this).val()).length == 0
    }).length == 0;
    console.log(checkInput);
    if(checkInput === true){
      console.log("true");
      $("#addtocart").prop("disabled", true);	
      $("#pz-confirmed").prop("disabled", false);
    }
    if(checkInput === false){
      console.log("false");
      $("#addtocart").prop("disabled", true);
      $("#pz-confirmed").prop("disabled", true);
    }
    $("#addtocart").prop("disabled", true);
  });
  var checkInput1 = $(".personalize__form--body input[type=text]").filter(function () {
    return $.trim($(this).val()).length == 0
  }).length == 0;
  console.log(checkInput1);
  // if(checkInput1 === true){
  //   console.log("true");
  //   $("#pz-confirmed").prop("disabled", false);
  // }else{
  //   $("#addtocart").prop("disabled", true);
  // }
  $('.personalize-wrapper-options').after('<p class="p_note">NOTE : Once you approve your personalization and submit your order, you can no longer modify, cancel or return your personalized product. Please allow 5-7 business days for personalization, plus additional time for shipping.</p>');

  /* Sticky Filter on Mobile */
  if ( $(window).width() < 768) {  
    //console.log("run Code");
    $(window).scroll(function() {    
      var scroll = $(window).scrollTop();

      if (scroll >= 160) {
        $(".js-collection-buttons .section__foot-inner").addClass("darkHeader");
      } else {
        $(".js-collection-buttons .section__foot-inner").removeClass("darkHeader");
      }
    }); 
  }
      setTimeout(function(){
    
  $("div.personalize__form--header").find('span._price').first().text("+$0.00");
  $("#personalized_start").on("click", function(){
    $("div.personalize__form--header").find('span._price').first().text($("div.personalize__form--header").find('span._price').last().text());  
  });
  $("#no_personalization").on("click", function(){
    $("div.personalize__form--header").find('span._price').first().text("+$0.00"); 
  });
  }, 3000);
});

window.setInterval(function(){
  $(".gift-note__row input").keypress(function (e) {
    var mainValue = $(this).val();
    //console.log(isEmoji(mainValue));
    var key = e.keyCode || e.which;       
    $('.no-special').remove();
    //Regular Expression
    var reg_exp = /^[A-Za-z0-9_\-~!@#$%^&*()+=?/,. ]+$/;
    //Validate Text Field value against the Regex.
    var is_valid = reg_exp.test(String.fromCharCode(key));
    if (!is_valid) {
      $('.gift-note__notice').after('<p class="no-special">We unfortunately cannot print emojis or symbols in gift notes.</p>');
    }
    console.log(is_valid);
    return is_valid;
  });
  
  function isEmoji(str) {
    var ranges = [
      '(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])' // U+1F680 to U+1F6FF
    ];
    if (str.match(ranges.join('|'))) {
      return true;
    } else {
      return false;
    }
  }
  
  /* On Hover Image PDP */
 /* $('.slick-slide').hover(function(){ 
    //console.log('Hi');
    $(this).trigger('click');
    $('.slick-slide').removeClass('slick-current');
    $(this).addClass('slick-current');
    var imgSrc = $(this).find('img').attr('src');
    var newImgsrc = imgSrc.replace("122x", "1270x");
    console.log(newImgsrc);
    $('.zoomContainer .zoomWindowContainer > div').css('background-image', 'url(' + newImgsrc + ')');
    $('.zoomContainer').css('background-image', 'url(' + newImgsrc + ')');
  });*/
  
  $('.cf-field input').on("focus", function() {
    $(this).parent().addClass('alt');
  }).on("blur", function() {
    if($(this).val() == ''){
       $(this).parent().removeClass('alt');
    }
    console.log($(this).val());
    
  });

  $(".cf-select-wrap select").children().first().text('');
  $("#169587").children().first().text('');
  
  $("#169587").change(function () {
        $(this).parent().parent().addClass('alt');
    });
  $("#694724").change(function () {
        $(this).parent().parent().addClass('alt');
    });
  
  
  if (!$("[data-cf-field-id='694724']").hasClass("alt")) {
    $("[data-cf-field-id='694724']").addClass('alt');
  }
},1000);

document.addEventListener( "DOMContentLoaded", load , false);

function load() {
  window.hlsVideo = hlsVideo( true , false );
}

function hlsVideo(init, showConsole = false) {
    let hlsObject = {
        mobileBreakpoint: 768,
        elements: [],
        mobileMedia: window.matchMedia("(max-width: 768px)"),
        init: function () {
            let videoElements = document.querySelectorAll('.hls-media');
            let parent = this;

            videoElements.forEach(function (video) {
                if (!video.initialized) {
                    let desktopSource = video.getAttribute('data-desktop-src');
                    let mobileSource = video.getAttribute('data-mobile-src');
                    let desktopPoster = video.getAttribute('data-desktop-poster');
                    let mobilePoster = video.getAttribute('data-mobile-poster');
                    let controlPlayer = video.getAttribute('data-controls');
                    let finalPoster = '';
                    let finalSource = '';
                    let windowWidth = window.outerWidth;

                    // Set poster
                    if (hlsObject.mobileMedia.matches) {
                        // Use mobile
                        if (mobilePoster && mobilePoster.length > 0) {
                            finalPoster = mobilePoster;
                        } else if (desktopPoster && desktopPoster.length > 0) {
                            finalPoster = desktopPoster;
                        } else {
                            console.warn('No desktop or mobile poster was specified for video element:', video);
                        }
                    } else {
                    
                        // desktop
                        if (desktopPoster && desktopPoster.length > 0) {
                            finalPoster = desktopPoster;
                        } else if (mobilePoster && mobilePoster.length > 0) {
                            finalPoster = mobilePoster;
                        } else {
                            console.warn('No desktop or mobile poster was specified for video element:', video);
                        }
                    }

                    if (finalPoster.length > 0) {
                        parent._setPoster(video, finalPoster);
                    }
                

                    if (showConsole) {
                        console.log('Initialized HLS playback on element', video);
                    }
                }
            });

            parent.sourceRebuild(this.mobileMedia);

        },
        _setSource: function (element, src) {
          // if the video is from shopify
          if ( src.includes('shopify') ) {
            element.src = src;
            element.addEventListener('loadedmetadata', function() {
              if (element.dataset.controls == false) {
                  element.play();
              }
            });

            return;
          } else if ( src.includes('youtube') ) {
            // stuff we need to do...
            element.classList.add('hidden');
            
            let closestParent = element.closest('.shopify-section');
            if ( closestParent ) {
              let idOfParent = closestParent.id;
              const injectionPointSelector = `#${idOfParent} .iframe-media`;
              let iframe = document.querySelector( injectionPointSelector );

              if ( iframe ) {
                let finalSrc = src;
                if ( element.dataset.controls == 'false' ) {
                  finalSrc += '&autoplay=1&playsinline=1&mute=1';
                } else {
                  finalSrc += '&autoplay=1&playsinline=1';
                }
                
                iframe.src = finalSrc;
              }
            }

            return;
          }


          if (Hls.isSupported()) {
              let hls = new Hls();
              hls.loadLevel = 4;

              element.pause();
              if ( showConsole ) {
                  console.log(element.dataset.controls);
              }

              hls.attachMedia(element);
              hls.on(Hls.Events.MEDIA_ATTACHED, function () {
              hls.loadSource(src);
              hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
                  if (element.dataset.controls == false) {
                      element.play();
                  }
                  
                  hls.startLevel = (hls.levels.length - 1);
              });
              });

          } else if (element.canPlayType('application/vnd.apple.mpegurl')) {
            element.src = src;
            element.addEventListener('loadedmetadata', function() {
              if (element.dataset.controls == false) {
                  element.play();
              }
            });
          } else {
              console.error('The browser does not support HLS or application/vnd.apple.mpegurl');
          }
        },
        _setPoster: function (element, poster) {
            element.setAttribute('poster', poster);
        },
        sourceRebuild: function(x) {
        // Build out HLS elements as needed
        // x = matched media | true = Mobile | false = Desktop
        let videoElements = document.querySelectorAll('.hls-media');
        videoElements.forEach(function (video) {
            try {
                let desktopSource = video.getAttribute('data-desktop-src');
                let mobileSource = video.getAttribute('data-mobile-src');
                let finalSource = '';

                if (x.matches) {

                    if (mobileSource && mobileSource.length > 0) {
                        finalSource = mobileSource;
                    } else if (desktopSource && desktopSource.length > 0) {
                        finalSource = desktopSource;
                    } else {
                        throw 'No desktop or mobile video source was specified for video element.'
                    }
                    
                } else {

                    if (desktopSource && desktopSource.length > 0) {
                        finalSource = desktopSource;
                    } else if (mobileSource && mobileSource.length > 0) {
                        finalSource = mobileSource;
                    } else {
                        throw 'No desktop or mobile video source was specified for video element.'
                    }

                }

                hlsObject._setSource(video, finalSource);


                video.initialized = true;


            } catch (videoError) {
                console.log("Video Unable to Load" + videoError);
            }                
        });
    },
    playVideo: function() {
        document.querySelectorAll('.hls-media').forEach(function (video) {
            video.play();
        });
    }
}

    hlsObject.init();
    document.addEventListener('shopify:section:load', function () {
        hlsObject.init();
    });

    // Use Event Listener for Edge/Chrome/Firefox - Fallback to Listener for Safari v14 and below
    try {
        hlsObject.mobileMedia.addEventListener("change", (e)=> {
            hlsObject.sourceRebuild(e);
        });
    } catch(eSafari) {
        try {
            hlsObject.mobileMedia.addListener(hlsObject.sourceRebuild(e));
        } catch (safariIsBuggy) {
            if (showConsole) { 
                console.log("Matched Media Error");
            }
        }
    }

    // Logic to build out autoplay for mobile only
    const hlsVideoContainers = document.querySelectorAll('.video-panel-section');
    const mobilePlayPauseButtons = {
        instances: []
    }

    let instances = [];
    let instance = {
        hls_source_element: null,   // reference to this instances .hls-media
        buttons_wrapper: null,      // reference to this instances [data-mobile-buttons]
        play_button: null,          // reference to the play button .play-button
        pause_button: null,         // reference to the pause button .pause-button
    }

    for ( let i = 0; i < hlsVideoContainers.length; i++ ) {
        instance.hls_source_element = hlsVideoContainers[i].querySelector('.hls-media');
        instance.buttons_wrapper = hlsVideoContainers[i].querySelector('[data-mobile-buttons]');
        instance.play_button =  hlsVideoContainers[i].querySelector('.play-button');
        instance.pause_button = hlsVideoContainers[i].querySelector('.pause-button');

        instances.push( instance );
        instance = {};
    }

    mobilePlayPauseButtons.instances = instances;

    if ( showConsole ) {
        console.log( mobilePlayPauseButtons );
    }

    // loop through each button instance. 
    // If the instance does not have the wrapper, autoplay it.
    for ( let instance of mobilePlayPauseButtons.instances ) {
        if ( instance.buttons_wrapper === null ) {
            instance.hls_source_element.play();
        }
        else {
            //check if the element is currently hidden
            if ( window.getComputedStyle( instance.buttons_wrapper ).display === "none" ) {
                instance.hls_source_element.play();
            } else {
                // if on desktop view, play the element like normal
                // if on mobile view, show play icon, hide pause icon
                instance.play_button.classList.remove('hidden');
                instance.pause_button.classList.add('hidden');

                // Attatch listners to play button
                instance.play_button.addEventListener('click' , ( e ) => {
                    instance.hls_source_element.play();
                    instance.play_button.classList.add('hidden');
                    instance.pause_button.classList.remove('hidden');
                    instance.buttons_wrapper.classList.remove('focus');
                });

                // Attach listenrs to pause button
                instance.pause_button.addEventListener('click' , ( e ) => {
                    instance.hls_source_element.pause();
                    instance.play_button.classList.remove('hidden');
                    instance.pause_button.classList.add('hidden');
                    instance.buttons_wrapper.classList.add('focus');
                });
            }
        }
    }

    function onPlayerReady( event ) {
      event.target.playVideo();
    }
    
    return hlsObject;
}

